import RichUpdatesItemTooltip from './RichUpdatesItemTooltip';

export default RichUpdatesItemTooltip;



// WEBPACK FOOTER //
// ./src/components/RichUpdates/RichUpdatesItem/RichUpdatesItemTooltip/index.tsx